import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Clock,
  MessageSquare,
  Building2,
  Globe,
  HelpCircle,
  ShieldCheck,
  UserCheck,
} from "lucide-react";
import CtaSection from "../CtaSection/CtaSection";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800 font-sans antialiased">
      <header className="border-b border-slate-200 bg-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
            Contact Us
          </h1>
          <p className="mt-2 text-base text-slate-600 max-w-2xl leading-relaxed">
            Have a question about payments, refunds, or technical support? Reach
            out to the BUMPPY PAYMENTS team through any of our official
            channels.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <a
            href="mailto:support@bumppy.com"
            className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-emerald-500 transition-colors flex flex-col justify-between space-y-3 group"
          >
            <div className="p-2.5 w-fit rounded-lg bg-emerald-50 text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-colors">
              <Mail size={20} />
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Email Support
              </p>
              <p className="text-sm font-semibold text-slate-900 truncate">
                support@bumppy.com
              </p>
              <p className="text-xs text-slate-500 mt-0.5">
                24/7 Response Window
              </p>
            </div>
          </a>

          <a
            href="tel:8130096175"
            className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-emerald-500 transition-colors flex flex-col justify-between space-y-3 group"
          >
            <div className="p-2.5 w-fit rounded-lg bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-colors">
              <Phone size={20} />
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Call Us
              </p>
              <p className="text-sm font-semibold text-slate-900 truncate">
                +918130096176
              </p>
              <p className="text-xs text-slate-500 mt-0.5">
                Mon–Sat, 10 AM – 7 PM
              </p>
            </div>
          </a>

          <a
            href="https://payments.bumppy.com"
            target="_blank"
            rel="noopener noreferrer"
            className="p-5 bg-white rounded-xl border border-slate-200 shadow-sm hover:border-emerald-500 transition-colors flex flex-col justify-between space-y-3 group"
          >
            <div className="p-2.5 w-fit rounded-lg bg-purple-50 text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-colors">
              <Globe size={20} />
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                Official Website
              </p>
              <p className="text-sm font-semibold text-slate-900 truncate">
                payments.bumppy.com
              </p>
            </div>
          </a>
        </div>

        <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-6">
          <div className="flex items-center gap-3.5 border-b border-slate-100 pb-4">
            <div className="p-2.5 bg-slate-100 text-slate-700 rounded-lg shrink-0">
              <Building2 size={22} />
            </div>
            <div>
              <h2 className="text-base sm:text-lg font-bold text-slate-900">
                Registered Office
              </h2>
              <p className="text-xs font-medium text-slate-500">
                BUMPPY PAYMENTS PRIVATE LIMITED
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-xs font-bold text-slate-400 uppercase tracking-wider">
                <MapPin size={14} className="text-emerald-600" />
                <span>Office Address</span>
              </div>
              <p className="text-xs sm:text-sm text-slate-700 leading-relaxed pl-5">
                B-218, Ithum Tower, Sector-62, Noida - 201301, Uttar Pradesh,
                India
              </p>
            </div>

            <div className="space-y-2">
              <div className="flex items-center gap-2 text-xs font-bold text-slate-400 uppercase tracking-wider">
                <Clock size={14} className="text-emerald-600" />
                <span>Business Hours</span>
              </div>
              <div className="text-xs sm:text-sm text-slate-700 space-y-0.5 pl-5">
                <p className="font-semibold text-slate-800">
                  Monday – Saturday:{" "}
                  <span className="font-normal text-slate-600">
                    10:00 AM – 7:00 PM
                  </span>
                </p>
                <p className="font-semibold text-slate-800">
                  Sunday:{" "}
                  <span className="font-normal text-slate-500">Closed</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <CtaSection />
    </div>
  );
};

export default ContactPage;
